// extracted by mini-css-extract-plugin
export default {"root":"IconDate_root__Dlw9U"};